import type { ResumedResult } from '@sentinel/api-client';

/**
 * Recognize a resumed federated-step-up result as a completed email-change
 * request, so the page can show the pending state after the IdP round trip
 * instead of silently swallowing the user's action.
 *
 * The channel carries the response body, not the request, so the caller cannot
 * learn which address was requested and must use the address-less copy.
 */
export function isResumedEmailChange(result: ResumedResult): boolean {
  if (!result.ok) return false;
  if (result.method.toUpperCase() !== 'PUT') return false;

  let path: string;
  try {
    path = new URL(result.url).pathname;
  } catch {
    path = result.url.split(/[?#]/, 1)[0] ?? result.url;
  }
  return path === '/auth/profile/email';
}
